import config from "../config"
import axios from "axios"
export default class APIService {
  serviceurl = config.apiurl;

  async postRequest(url, body) {
    try {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      const response = await fetch(this.serviceurl + url, {
        method: "post",
        headers: headers,
        body: JSON.stringify(body),
      });
      if (response.status == 401) { return response; } else if (response.status == 400) { return response; } else if (response.status == 200 || response.status == 201) {
        const data = await response.json();
        return data;
      } else {return response; }
    } catch (error) {

    }
    return [];
  }

  async axiospostbodyRequest(url, body) {
    try {
      const response = await axios.post(this.serviceurl + url, {
        headers: {
          "content-type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(body),
      });
      if (response.status == 401) {return response; } else if (response.status == 400) { return response; } else if (response.status == 200 || response.status == 201) {
        const data = await response.json();
        return data;
      } else { return response; }
    } catch (error) {

    }
    return [];
  }


  async axiosPostRequest(url, formdata) {
    try {
      const resp = await axios.post(this.serviceurl + url, formdata, {
        headers: {
          "content-type": "multipart/form-data",
        },
      });
      return resp.data;
    } catch (ex) {
      console.log(ex)

    }
  }

  async axiospostbodyRequest(url, body) {
    try {
      const response = await axios.post(this.serviceurl + url, {
        headers: {
          "content-type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(body),
      });
      if (response.status == 401) { } else if (response.status == 400) { } else if (response.status == 200 || response.status == 201) {
        const data = await response.json();
        return data;
      } else { }
    } catch (error) {
 
    }
    return [];
  }

  async getRequest(url) {
    try {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      //headers.append('Authorization', 'Basic ' + base64.encode(username + ":" + password));
      headers.append('Origin', 'http://localhost:3000');
      const response = await fetch(this.serviceurl + url, {
        method: "get",
        headers: headers,
      });
      if (response.status == 401) { } else if (response.status == 400) { } else if (response.status == 200 || response.status == 201) {
        const data = await response.json();
        return data;
      } else { }
    } catch (error) {

    }
    return [];
  }

  async postFileRequest(url, body) {
    try {
      var request = new XMLHttpRequest()
      request.open("POST", this.serviceurl + url)
      request.send(body)

      // let headers = new Headers();
      // //headers.append('Authorization', 'Basic ' + base64.encode(username + ":" + password));
      // headers.append('Content-Type', 'multipart/form-data');
      // headers.append('Accept', '*/*');
      // //headers.append('Origin', 'http://localhost:3000');
      // const response = await fetch(this.serviceurl + url, {
      //   method: "post",
      //   headers: headers,
      //   body: body,
      // });
      // if (response.status == 401) { } else if (response.status == 400) { } else if (response.status == 200 || response.status == 201) {
      //   const data = await response.json();
      //   return data;
      // } else { }
    } catch (error) {

    }
    return [];
  }

  getRequestUrl(url) {
    return this.serviceurl + url;
  }
}